import React from 'react'
import { useNavigate } from 'react-router-dom'
import VUSeal from './VUSeal'
import './NotFound.css'

export default function NotFound() {
  const navigate = useNavigate()
  return (
    <div className="nf">
      <div className="nf-card">
        <div className="nf-seal"><VUSeal size={100} /></div>
        <h1 className="nf-title">Page not found.</h1>
        <p className="nf-body">The page you are looking for does not exist or has moved.</p>
        <button className="nf-btn" onClick={() => navigate('/')}>Back to Vacatia University</button>
      </div>
    </div>
  )
}
